// extracted by mini-css-extract-plugin
export var container = "_95-0";